import React, { useEffect } from 'react';
import { MapContainer, TileLayer, Rectangle, useMap } from 'react-leaflet';

/**
 * Component to handle map center updates when props change
 */
const MapUpdater = ({ mapCenter }) => {
  const map = useMap();

  useEffect(() => {
    if (Array.isArray(mapCenter) && mapCenter.length === 2) {
      map.setView(mapCenter, map.getZoom());
    }
  }, [mapCenter, map]);

  return null;
};

/**
 * Simple read-only map component for playground mode
 * Shows a map with a rectangle bounds without interactive controls
 */
const PlaygroundMapComponent = ({ mapCenter, zoom, rectangleBounds }) => {
  const validCenter = Array.isArray(mapCenter) && mapCenter.length === 2
    ? mapCenter
    : [48.1351, 11.5820]; // Default to Munich

  const validBounds = rectangleBounds && Array.isArray(rectangleBounds)
    ? rectangleBounds
    : [[48.1, 11.4], [48.2, 11.6]];

  return (
    <div className="w-full h-full">
      <MapContainer
        center={validCenter}
        zoom={zoom || 9}
        style={{ height: '100%', width: '100%' }}
        zoomControl={false}
        scrollWheelZoom={false}
        doubleClickZoom={false}
        dragging={false}
        touchZoom={false}
        keyboard={false}
      >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; OpenStreetMap contributors'
        />
        <Rectangle
          bounds={validBounds}
          pathOptions={{ color: 'blue', weight: 5, fillOpacity: 0 }}
        />
        <MapUpdater mapCenter={mapCenter} />
      </MapContainer>
    </div>
  );
};

export default PlaygroundMapComponent;
